// extracted by mini-css-extract-plugin
export default {"Select":"Input_Select__T19Mz","Input":"Input_Input__ZqIpW"};